export default "__VITE_ASSET__Ck2Shqi8__"